import { booleanAttribute } from "#ce/utils/props";
import { props as textFieldProps } from "#ce/components/SpTextField/props.js";

// We had bugs in the past, where the props were mutatated. Apply Object.freeze() to prevent this.
export const props = Object.freeze({
  ...textFieldProps,
  /**
   * Clears the input field when the clear button is clicked.
   * This will render a clear button on the right side of the input field.
   * This will only be visible when the input field is not empty.
   *
   * @type {Boolean|String}
   * @default false
   */
  clearable: booleanAttribute(),
  placeholder: {
    ...textFieldProps.placeholder,
    default: "Search",
  },
});
